import { render, staticRenderFns } from "./vipcardinfo.vue?vue&type=template&id=223b771c&scoped=true&"
import script from "./vipcardinfo.vue?vue&type=script&lang=js&"
export * from "./vipcardinfo.vue?vue&type=script&lang=js&"
import style0 from "./vipcardinfo.vue?vue&type=style&index=0&id=223b771c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b771c",
  null
  
)

export default component.exports